module.exports = __webpack_public_path__ + "img/PR.4215b079.png";